import { PORTAL_LINK } from 'utils/whiteLabeling';

export const INITIAL_SERVICE_LIMIT = 100;
export const INITIAL_CERTIFICATES_LIMIT = 100;
export const MAX_LIMIT = 1000;

export const DOCS_LINK = `${PORTAL_LINK}/api/2.6/docs`;
export const API_DOCS_LINK = `${PORTAL_LINK}/api/2.6/docs/api`;

export const PROMOS_OPTIONS_GROUP = 'Promos';
export const DEFAULT_OPTIONS_GROUP = 'Miscellaneous';

export const SESSION_STORAGE_OAUTH_ACTION = 'oauthAction';
